import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitModal() {
    this.updateHiddenField()
    this.updateStudentTable()
  }

  updateHiddenField() {
    const hiddenInput = document.getElementById("selected_student_ids")
    hiddenInput.value = batch_action_ids.join(",")
  }

  updateStudentTable() {
    const tableContainer = document.getElementById("addstudentoclass")
    const rows = batch_action_ids.map(id => {
      const row = document.getElementById(`student-row-${id}`)
      const name = row?.querySelectorAll("td")[1]?.textContent?.trim() || "Unknown"
      return `<tr><td class="text-center">${name}</td></tr>`
    }).join("")
    tableContainer.innerHTML = `<table class="table">${rows}</table>`
  }
}
